(() => {
  const roots = document.querySelectorAll('[data-absora-listicle]');

  roots.forEach((root) => {
    if (root.dataset.listicleInitialized === 'true') return;
    root.dataset.listicleInitialized = 'true';

    const track = root.querySelector('[data-al-track]');
    const slides = track ? Array.from(track.children) : [];
    const counters = root.querySelectorAll('[data-al-count]');
    const previous = root.querySelector('[data-al-prev]');
    const next = root.querySelector('[data-al-next]');
    let index = 0;

    const renderCarousel = () => {
      if (!track || slides.length === 0) return;
      track.style.transform = `translateX(-${index * 100}%)`;
      counters.forEach((counter) => {
        counter.textContent = `${index + 1} of ${slides.length}`;
      });
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    previous?.addEventListener('click', () => {
      index = Math.max(0, index - 1);
      renderCarousel();
    });
    next?.addEventListener('click', () => {
      index = Math.min(slides.length - 1, index + 1);
      renderCarousel();
    });
    renderCarousel();

    const packs = Array.from(root.querySelectorAll('[data-al-pack]'));
    const variantInput = root.querySelector('[data-al-variant-input]');
    const submit = root.querySelector('[data-al-submit]');

    const selectPack = (pack) => {
      packs.forEach((candidate) => {
        const selected = candidate === pack;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', String(selected));
      });
      if (variantInput) variantInput.value = pack.dataset.variantId || '';
      if (submit) submit.textContent = `ADD TO CART — ${pack.dataset.price || ''}`;
    };

    packs.forEach((pack) => {
      pack.addEventListener('click', () => selectPack(pack));
    });

    const selected = packs.find((pack) => pack.classList.contains('is-selected')) || packs[0];
    if (selected) selectPack(selected);

    const mechanism = root.querySelector('[data-liver-mechanism]');
    const mechanismReplay = root.querySelector('[data-liver-replay]');
    let mechanismTimers = [];
    let mechanismFrame = 0;
    let mechanismObserver = null;

    const clearMechanismTimers = () => {
      mechanismTimers.forEach((timer) => window.clearTimeout(timer));
      mechanismTimers = [];
      window.cancelAnimationFrame(mechanismFrame);
      mechanismFrame = 0;
    };

    const resetMechanism = () => {
      if (!mechanism) return;
      clearMechanismTimers();
      mechanism.removeAttribute('data-lv-active');
      mechanism.removeAttribute('data-lv-rm');
      mechanism.querySelectorAll('[data-lv-rest]').forEach((particle) => {
        particle.style.offsetDistance = '';
        particle.style.opacity = '';
      });
      const counter = mechanism.querySelector('[data-lv-count]');
      if (counter) counter.textContent = '80';
      mechanism.setAttribute('data-lv-reset', '');
      void mechanism.offsetWidth;
      mechanism.removeAttribute('data-lv-reset');
    };

    const startMechanism = (force = false) => {
      if (!mechanism || (!force && mechanism.dataset.liverStarted === 'true')) return;
      mechanism.dataset.liverStarted = 'true';
      clearMechanismTimers();
      const counter = mechanism.querySelector('[data-lv-count]');
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        mechanism.setAttribute('data-lv-rm', '');
        mechanism.querySelectorAll('[data-lv-rest]').forEach((particle) => {
          particle.style.offsetDistance = particle.getAttribute('data-lv-rest') || '60%';
          particle.style.opacity = '1';
        });
        if (counter) counter.textContent = '80';
        return;
      }
      mechanism.setAttribute('data-lv-active', '');
      if (!counter) return;
      counter.textContent = '0';
      mechanismTimers.push(window.setTimeout(() => {
        const startedAt = performance.now();
        const step = (now) => {
          const progress = Math.min(1, (now - startedAt) / 900);
          counter.textContent = String(Math.round((1 - Math.pow(1 - progress, 3)) * 80));
          if (progress < 1) mechanismFrame = window.requestAnimationFrame(step);
        };
        mechanismFrame = window.requestAnimationFrame(step);
      }, 700));
    };

    if (mechanism) {
      if ('IntersectionObserver' in window) {
        mechanismObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            mechanismObserver.disconnect();
            startMechanism();
          }
        }, { threshold: 0.25 });
        mechanismObserver.observe(mechanism);
      } else startMechanism();
    }

    mechanismReplay?.addEventListener('click', () => {
      resetMechanism();
      startMechanism(true);
    });

    root.addEventListener('shopify:section:unload', () => {
      mechanismObserver?.disconnect();
      clearMechanismTimers();
    }, { once: true });
  });
})();
